import { CreditUsageConstants } from './CreditUsage.constants';

const initialState = {
  creditUsageData: {},
  creditUsageChartData: {},
  creditDetails: {},
  creditUsageSummary: {}
};

const CreditUsageReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Get Credit Usage Data List
    case CreditUsageConstants.GET_CREDIT_USAGE_LIST_REQUEST:
      return {
        ...state,
        creditUsageData: {
          loading: true,
          error: false
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_LIST_SUCCESS:
      return {
        ...state,
        creditUsageData: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_LIST_ERROR:
      return {
        ...state,
        creditUsageData: {
          loading: false,
          error: true
        }
      };

    // --- Get Credit Usage Chart Data List
    case CreditUsageConstants.GET_CREDIT_USAGE_CHART_REQUEST:
      return {
        ...state,
        creditUsageChartData: {
          loading: true,
          error: false
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_CHART_SUCCESS:
      return {
        ...state,
        creditUsageChartData: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_CHART_ERROR:
      return {
        ...state,
        creditUsageChartData: {
          loading: false,
          error: true
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_LIST_REQUEST:
      return {
        ...state,
        creditUsageSummary: {
          loading: true,
          error: false
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_SUMMARY_SUCCESS:
      return {
        ...state,
        creditUsageSummary: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case CreditUsageConstants.GET_CREDIT_USAGE_SUMMARY_ERROR:
      return {
        ...state,
        creditUsageSummary: {
          loading: false,
          error: true
        }
      };

    // --- GET account bill plan
    case CreditUsageConstants.GET_CREDIT_DETAILS_REQUEST:
      return {
        ...state,
        creditDetails: {
          loading: true,
          error: false
        }
      };

    case CreditUsageConstants.GET_CREDIT_DETAILS_SUCCESS:
      return {
        ...state,
        creditDetails: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case CreditUsageConstants.GET_CREDIT_DETAILS_ERROR:
      return {
        ...state,
        creditDetails: {
          loading: false,
          error: true
        }
      };

    default:
      return state;
  }
};

export default CreditUsageReducer;
